var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-badge"},[_vm._t("default"),_c('sup',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hidden && _vm.isDot),expression:"!hidden && isDot"}],staticClass:"app-badge__content",class:[
            'app-badge__content--' + _vm.type
        ]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }